// document.addEventListener('DOMContentLoaded', () => {
//   setupEventListeners();
//   updateButtonDataId();
//   setTimeout(()=>{
//      document.querySelectorAll('.wc-variant-list').forEach((list) => {
//       const selectElement = list.querySelector('select');
//       if (selectElement) {
//         selectElement.selectedIndex = 0;
//       }
//     });
//   },1000);
// });

// function setupEventListeners() {
//   document.querySelectorAll('.wc-radio').forEach((radio) => {
//     radio.addEventListener('change', () => {

//       document.querySelectorAll('.wc-variant-list').forEach((list) => {
//         list.classList.remove('active');
//         const selectElement = list.querySelector('select');
//         if (selectElement) {
//           selectElement.selectedIndex = 0;
//         }
//       });

//       const activeVariantList = document.querySelector('.wc-radio:checked')?.closest('.wc-variant-list');
//       if (activeVariantList) {
//         activeVariantList.classList.add('active');
//       }
//       updateButtonDataId();
//     });
//   });

//   document.querySelectorAll('.wc-variant-list select').forEach((selectElement) => {
//     selectElement.addEventListener('change', () => {
//       updateButtonDataId();
//     });
//   });
// }

// function updateButtonDataId() {
//   const activeVariantList = document.querySelector('.wc-variant-list.active');
//   const addToCartButton = document.querySelector('.custom-add');

//   if (activeVariantList && addToCartButton) {
//     const selectElement = activeVariantList.querySelector('select');
//     if (!selectElement) return;

//     const selectedOption = selectElement.options[selectElement.selectedIndex];
//     const variantId = selectedOption.getAttribute('data-variant-id');
//     const src = selectedOption.getAttribute('data-src');

//     document.querySelectorAll(".product-gallery__thumbnail").forEach(thumbnail => {
//       if (thumbnail.getAttribute("href") === src) {
//         thumbnail.click();
//       }
//     });

//     if (activeVariantList.getAttribute("data-id") === "subscribe") {
//       const firstThumbnail = document.querySelector(".product-gallery__thumbnail");
//       if (firstThumbnail) {
//         firstThumbnail.click();
//       }
//     }

//     if (variantId) {
//       const url = new URL(window.location);
//       url.searchParams.set('variant', variantId);
//       history.replaceState(null, '', url);
//     }

//     const price = selectedOption.getAttribute('data-price');
//     const compare = selectedOption.getAttribute('data-compare-price');
//     const regularPrice = activeVariantList.querySelector('.price-regular');
//     const comparePrice = activeVariantList.querySelector('.price-compare');

//     if (regularPrice && price) {
//       regularPrice.textContent = price;
//       document.querySelector('.price-list .price--highlight').textContent = price;
//     }

//     if (comparePrice && compare) {
//       comparePrice.textContent = compare;
//       document.querySelector('.price-list .price--compare').textContent = compare;
//       document.querySelector('.price-list .br').style.display = 'block';
//       document.querySelector('.product-meta__label-list').style.display = 'block';
//       document.querySelectorAll('.price-list .crossout-price').forEach(e => {
//         e.style.display = 'inline-block';
//       });
//     } else {
//       document.querySelector('.price-list .price--compare').textContent = '';
//       document.querySelectorAll('.price-list .crossout-price').forEach(e => {
//         e.style.display = 'none';
//       });
//       document.querySelector('.product-meta__label-list').style.display = 'none';
//       document.querySelector('.price-list .br').style.display = 'none';
//       if (comparePrice) comparePrice.textContent = '';
//     }

//     addToCartButton.setAttribute('data-id', variantId || '');
//   }
// }

document.addEventListener("DOMContentLoaded", () => {
  preselectVariantFromURL();
  setupEventListeners();

  // Delay the inventory check to ensure everything is set first
  setTimeout(() => {
    updateButtonDataId();
    checkInventory();
  }, 500);
});

function preselectVariantFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (!variantId) return;

  let found = false;

  document
    .querySelectorAll(".wc-option-wrapper select")
    .forEach((selectElement) => {
      selectElement.querySelectorAll("option").forEach((option) => {
        if (option.getAttribute("data-variant-id") === variantId) {
          option.selected = true;
          found = true;

          const variantList = option.closest(".wc-variant-list");
          if (variantList) {
            document
              .querySelectorAll(".wc-variant-list")
              .forEach((list) => list.classList.remove("active"));
            variantList.classList.add("active");

            const radioInput = variantList.querySelector(".wc-radio");
            if (radioInput) {
              radioInput.checked = true;
            }
          }

          selectElement.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });

  if (!found) {
    console.warn("Variant ID from URL not found in options.");
  }
}

function setupEventListeners() {
  document.querySelectorAll(".wc-radio").forEach((radio) => {
    radio.addEventListener("change", () => {
      document
        .querySelectorAll(".wc-variant-list")
        .forEach((list) => list.classList.remove("active"));

      const activeVariantList = radio.closest(".wc-variant-list");
      if (activeVariantList) {
        activeVariantList.classList.add("active");
      }

      updateButtonDataId();
      checkInventory();
      th_disable_main_atc_btn_logic();
    });
  });

  document
    .querySelectorAll(".wc-variant-list select")
    .forEach((selectElement) => {
      selectElement.addEventListener("change", () => {
        updateButtonDataId();
        checkInventory();

        const variantList = selectElement.closest(".wc-variant-list");

        if (variantList) {
          document
            .querySelectorAll(".wc-variant-list")
            .forEach((list) => list.classList.remove("active"));
          variantList.classList.add("active");

          const radioInput = variantList.querySelector(".wc-radio");
          if (radioInput) {
            radioInput.checked = true;
          }
        }
      });
    });
}

function updateButtonDataId() {
  const activeVariantList = document.querySelector(".wc-variant-list.active");
  const addToCartButton = document.querySelector(".custom-add");
  const hiddenInput = document.querySelector(
    '.product-form__option input[name="id"]'
  );

  if (activeVariantList && addToCartButton) {
    const selectElement = activeVariantList.querySelector("select");
    if (!selectElement) return;

    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const variantId = selectedOption.getAttribute("data-variant-id");
    const selling = selectedOption.getAttribute("data-selling-plan");
    const src = selectedOption.getAttribute("data-src");

    document
      .querySelectorAll(".product-gallery__thumbnail")
      .forEach((thumbnail) => {
        if (thumbnail.getAttribute("href") === src) {
          thumbnail.click();
        }
      });

    if (activeVariantList.getAttribute("data-id") === "subscribe") {
      const firstThumbnail = document.querySelector(
        ".product-gallery__thumbnail"
      );
      if (firstThumbnail) {
        firstThumbnail.click();
      }
    }

    if (variantId) {
      const url = new URL(window.location);

      if (url.searchParams.get("variant") !== variantId) {
        url.searchParams.set("variant", variantId);
        history.replaceState(null, "", url);
      }

      if (hiddenInput) {
        hiddenInput.value = variantId;
      }
    }

    const price = selectedOption.getAttribute("data-price");
    const compare = selectedOption.getAttribute("data-compare-price");
    const regularPrice = activeVariantList.querySelector(".price-regular");
    const comparePrice = activeVariantList.querySelector(".price-compare");

    if (regularPrice && price) {
      regularPrice.textContent = price;
      document.querySelector(".price-list .price--highlight").textContent =
        price;
    }

    if (comparePrice && compare) {
      comparePrice.textContent = compare;
      document.querySelector(".price-list .price--compare").textContent =
        compare;
      document.querySelector(".price-list .br").style.display = "block";
      document.querySelector(".product-meta__label-list").style.display =
        "block";
      document.querySelectorAll(".price-list .crossout-price").forEach((e) => {
        e.style.display = "inline-block";
      });
    } else {
      document.querySelector(".price-list .price--compare").textContent = "";
      document.querySelectorAll(".price-list .crossout-price").forEach((e) => {
        e.style.display = "none";
      });
      document.querySelector(".product-meta__label-list").style.display =
        "none";
      document.querySelector(".price-list .br").style.display = "none";
      if (comparePrice) comparePrice.textContent = "";
    }
    addToCartButton.setAttribute("data-id", variantId || "");
    addToCartButton.setAttribute("data-selling-plan", selling || "");
  }
  checkInventory();
}

function checkInventory() {
  const activeVariantList = document.querySelector(".wc-variant-list.active");

  if (!activeVariantList) return;

  const selectElement = activeVariantList.querySelector("select");
  if (!selectElement) return;

  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const inventory = parseInt(selectedOption.getAttribute("data-inventory"), 10);

  const addToCartButton = document.querySelector(".custom-add");
  const soldOutButton = document.querySelector(".product-form__sold-button");
  const paymentButton = document.querySelector(".addonpayments");
  const notify = document.querySelector(".cc-stock-55055748");
  const Itemavailable = selectedOption.getAttribute("data-variant-available");
  console.log('Itemavailable', Itemavailable);
  if (Itemavailable == 'false') {
    addToCartButton.style.display = "none";
    if (notify) {
      notify.style.display = "block";
    }
    soldOutButton.style.display = "block";
    if (paymentButton !== null) {
      paymentButton.style.display = "none";
    }
  } else {
    addToCartButton.style.display = "block";
    if (notify) {
      notify.style.display = "none";
    }
    soldOutButton.style.display = "none";
    if (paymentButton !== null) {
      document
        .querySelector("shop-pay-wallet-button")
        .removeAttribute("disabled");
      paymentButton.style.display = "block";
    }
  }
}

// setTimeout(() => {
//   const addToCartBtn = document.querySelector('.custom-add');

//   if (addToCartBtn) {
//     addToCartBtn.addEventListener('click', function () {
//       const varid = this.getAttribute('data-id');
//       const qnty = this.getAttribute('data-qnty');

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: varid,
//           quantity: qnty
//         }),
//         cache: 'no-cache'
//       })
//         .then(response => response.json())
//         .then(data => {
//           cartDrawerUpdate();
//           setTimeout(() => {
//             if (window.innerWidth <= 640) {
//               updateCartDrawerMobile(data);
//             } else {
//               updateCartDrawer(data);
//             }
//           }, 1000);
//         })
//         .catch(error => {
//           console.log("Error:", error);
//         });
//     });
//   }
// }, 1000);

setTimeout(() => {
  const addToCartBtn = document.querySelector(".custom-add");

  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function () {
      const varid = this.getAttribute("data-id");
      const qnty = this.getAttribute("data-qnty");
      const sellingPlanId = this.getAttribute("data-selling-plan");

      const requestBody = {
        id: varid,
        quantity: qnty,
      };

      if (sellingPlanId) {
        requestBody.selling_plan = sellingPlanId;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
        cache: "no-cache",
      })
        .then((response) => response.json())
        .then((data) => {
          cartDrawerUpdate();
          setTimeout(() => {
            if (window.innerWidth <= 640) {
              updateCartDrawerMobile(data);
            } else {
              updateCartDrawer(data);
            }
          }, 1000);
        })
        .catch((error) => {
          console.log("Error:", error);
        });
    });
  }
}, 1000);

function updateCartDrawer(data) {
  document
    .querySelector(".header__cart-toggle")
    ?.setAttribute("aria-expanded", "true");
  document.querySelector(".mini-cart")?.setAttribute("aria-hidden", "false");
}
function updateCartDrawerMobile(data) {
  document
    .querySelectorAll(
      ".header__action-item--cart .header__cart-toggle,.header__action-item--cart .icon-state"
    )
    .forEach((element) => {
      element.setAttribute("aria-expanded", "true");
    });
  document
    .querySelector(".header__action-item--cart .mini-cart")
    .setAttribute("aria-hidden", "false");
  document.querySelector(
    ".header__action-item--cart .mini-cart"
  ).style.maxHeight = "100vh";
  document
    .querySelector(".header__action-item--cart .icon-state__secondary")
    .click();
  document.body.classList.add("no-mobile-scroll");
}
function cartDrawerUpdate() {
  var url = window.location.href;
  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      if (doc.querySelector("#mini-cart") != null) {
        var mainSectionContent = doc.querySelector("#mini-cart").innerHTML;
        document.querySelector("#mini-cart").innerHTML = mainSectionContent;
      }
      setTimeout(function () {
        if (doc.querySelector(".mini-cart__recap") != null) {
          var mainSectionContent =
            doc.querySelector(".mini-cart__recap").innerHTML;
          document.querySelector(".mini-cart__recap").innerHTML =
            mainSectionContent;
        }
      }, 1200);
      if (doc.querySelector(".header__cart-count") != null) {
        var mainSectionContent = doc.querySelector(
          ".header__cart-count"
        ).innerHTML;
        document.querySelector(".header__cart-count").innerHTML =
          mainSectionContent;
      }
    })
    .catch((error) => {
      console.error("Error fetching collection main section:", error);
    });
}

document.addEventListener("click", function (event) {
  const cartToggle = document.querySelector(".header__cart-toggle");

  if (cartToggle && cartToggle.getAttribute("aria-expanded") === "true") {
    const miniCart = document.getElementById("mini-cart");

    if (
      miniCart &&
      !miniCart.contains(event.target) &&
      !cartToggle.contains(event.target)
    ) {
      cartToggle.setAttribute("aria-expanded", "false");
      document.querySelector(".mini-cart").setAttribute("aria-hidden", "true");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let quantityInput = document.querySelector(".quantity-selector__value");
  let increaseButton = document.querySelector(
    '[data-action="increase-picker-quantity"]'
  );
  let decreaseButton = document.querySelector(
    '[data-action="decrease-picker-quantity"]'
  );

  let quantityValue = parseInt(quantityInput.value, 10) || 0;

  function updateQuantity(change) {
    quantityValue += change;
    if (quantityValue < 1) quantityValue = 1;
    document
      .querySelector(".custom-add")
      .setAttribute("data-qnty", quantityValue);
  }

  increaseButton.addEventListener("click", function () {
    updateQuantity(1);
  });

  decreaseButton.addEventListener("click", function () {
    updateQuantity(-1);
  });
});

// wc abhi

const variantLists = document.querySelectorAll(".wc-variant-list");
const addToCartButton = document.querySelector(".custom-add");

let lastSelectedOption = null;

function handleOptionChange(option) {
  if (!option) return;

  const sellingPlan = option.getAttribute("data-selling-plan");
  // console.log("Selected option:", option.value);
  // console.log("Selling plan value:", sellingPlan);

  if (sellingPlan) {
    addToCartButton?.removeAttribute("disabled");
    // console.log("Selling plan exists → disabled not added");
  } else {
    addToCartButton?.setAttribute("disabled", "disabled");
    // console.log("No selling plan → disabled added");
  }
}

let th_disable_main_atc_btn_logic = () => {
  let is_selected_plan_not_active = document.querySelector(
    `.wc-variant-list.active[data-id="subscribe"] .variant-select option:checked[data-selling-plan='']`
  );
  let th_main_ATC_btn = document.querySelector(
    ".product-form__info-list .custom-add.button.button--primary"
  );
  let th_buy_with_shop_btn = document.querySelector(
    ".product-form__info-list .shopify-payment-button"
  );
  if (is_selected_plan_not_active) {
    th_main_ATC_btn.setAttribute("disabled", "");
    th_buy_with_shop_btn.setAttribute("disabled", "");
  } else {
    th_main_ATC_btn.removeAttribute("disabled", "");
    th_buy_with_shop_btn.removeAttribute("disabled", "");
  }
};
function bindSelectListener(select) {
  if (!select.dataset.listenerAttached) {
    select.addEventListener("change", (e) => {
      const option = e.target.selectedOptions[0];

      if (option !== lastSelectedOption) {
        lastSelectedOption = option;
        handleOptionChange(option);
      }
      th_disable_main_atc_btn_logic();
    });
    select.dataset.listenerAttached = "true";
  }
}

variantLists.forEach((variantList) => {
  const radio = variantList.querySelector('input[type="radio"]');

  if (radio) {
    radio.addEventListener("change", () => {
      const selectedId = variantList.dataset.id;
      console.log("selling_plan_change_____________________");
      // console.log("Selected data-id:", selectedId);

      if (selectedId === "subscribe") {
        const select = variantList.querySelector("select");
        if (select) {
          const option = select.selectedOptions[0];
          handleOptionChange(option);
          bindSelectListener(select);
        }
      } else {
        addToCartButton?.removeAttribute("disabled");
        console.log("Another variant selected → disabled not added");
      }
      th_disable_main_atc_btn_logic();
    });
  }
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (
      mutation.type === "attributes" &&
      mutation.attributeName === "data-selling-plan"
    ) {
      const option = mutation.target;
      if (option.selected) {
        console.log("Detected manual change in data-selling-plan");
        handleOptionChange(option);
      }
    }
  });
});

document.querySelectorAll("select option").forEach((option) => {
  observer.observe(option, {
    attributes: true,
    attributeFilter: ["data-selling-plan"],
  });
});

// name="selling_plan" on change work

document.addEventListener("DOMContentLoaded", function () {
  const subscribeWrapper = document.querySelector(
    '.wc-variant-list[data-id="subscribe"]'
  );
  const oneTimeWrapper = document.querySelector(
    '.wc-variant-list[data-id="one-time"]'
  );
  const sellingPlanInput = document.querySelector(".selling_plan_id");

  if (!subscribeWrapper || !oneTimeWrapper || !sellingPlanInput) return;

  const select = subscribeWrapper.querySelector(".variant-select");
  if (select) {
    select.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      const sellingPlanId = selectedOption.getAttribute("data-selling-plan");
      sellingPlanInput.value = sellingPlanId || "";
    });

    const initialSelected = select.options[select.selectedIndex];
    if (initialSelected && initialSelected.hasAttribute("data-selling-plan")) {
      sellingPlanInput.value =
        initialSelected.getAttribute("data-selling-plan") || "";
    }
  }

  document.querySelectorAll('input[name="sub-radio"]').forEach((radio) => {
    radio.addEventListener("change", function () {
      if (this.id === "variant") {
        sellingPlanInput.value = "";
      } else if (this.id === "subscription" && select) {
        const selectedOption = select.options[select.selectedIndex];
        const sellingPlanId = selectedOption.getAttribute("data-selling-plan");
        sellingPlanInput.value = sellingPlanId || "";
      }
    });
  });
});

// wc abhi
